import { useContext } from 'react';
import { UserV3Context, userV3Ctx } from '../contexts';

export function useUserV3(): UserV3Context {
  const ctxValue = useContext(userV3Ctx);

  if (!ctxValue) {
    throw new Error(`UserV3 context is undefined, please verify you have added the UserV3Provider component.`);
  }

  return ctxValue;
}
